import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Panel, Button, Col, Row } from 'react-bootstrap';
import { Input, DateTimeInput, FormActions } from '../../common/components/formControls';
import TermsDropdownList from '../terms/DropdownList';
import CentersDropdownList from '../centers/DropdownList';
import { withTranslation } from 'react-i18next';
import utils from '../../common/services/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

const Filter = ({ handleSubmit, onReset, initialize, loading, t }) => {
	const handleReset = () => {
		initialize({});
		onReset();
	};
	return (
		<Panel>
			<Panel.Heading><FontAwesomeIcon icon={faFilter} />{t('Common_Filter')}</Panel.Heading>
			<Panel.Body>
				<form onSubmit={handleSubmit}>
					<Row>
						<Col sm={6}>
							<CentersDropdownList render='field' name='centerId' label={t('TrialLesson_Center')} />
						</Col>
						<Col sm={6}>
							<Field name='childName' component={Input} type='text' label={t('TrialLesson_Child')} />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Field name='isAttended' component={Input} componentClass='select' label={t('TrialLesson_IsAttended')}>
								<option value={''}>{t('Common_All')}</option>
								<option value={true}>{t('Common_Yes')}</option>
								<option value={false}>{t('Common_No')}</option>
							</Field>
						</Col>
						<Col sm={6}>
							<TermsDropdownList render='field' name='termId' label={t('TrialLesson_Term')} />
						</Col>
					</Row>
					<Row>

						<Col sm={3}>
							<Field name='dateFrom' component={DateTimeInput} showTime={false} defaultCurrentDate={utils.defaultDatePeriodFrom()} label={t('TrialLesson_Date')} placeholder={t('Common_From')} />
						</Col>
						<Col sm={3}>
							<Field name='dateTo' component={DateTimeInput} showTime={false} defaultCurrentDate={utils.defaultDatePeriodTo()} placeholder={t('Common_To')} label='&nbsp;' />
						</Col>
					</Row>

					<FormActions>
						<Button type='submit' disabled={loading} bsStyle='primary'>{t('Common_Filter')}</Button>
						<Button disabled={loading} onClick={handleReset}>{t('Common_Reset')}</Button>
					</FormActions>
				</form>
			</Panel.Body>
		</Panel>
	);
};

Filter.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'trialLessonsFilter' })(withTranslation()(Filter));